import { useAppSelector } from "store";
import TrailTable from "components/common/TrailTable/TrailTable";

const GamesTrailTab: React.FC = () => {
  const game = useAppSelector((store) => store.games.item);

  const entityId = game?.id;

  return (
    <>
      <TrailTable entityType="game" entityId={Number(entityId)} />
    </>
  );
};

export default GamesTrailTab;
